<div class="flex min-h-vh justify-center items-center px-16px">
  <div class="max-w-450px">
    <ib-logo-name-horizontal
      class="w-220px mb-14 mx-auto"
    ></ib-logo-name-horizontal>
    <div class="text-80px text-center text-secondary font-semibold">404</div>
    <div class="mt-10 text-30px text-center">Page Not Found</div>
    <div class="mt-10 text-center">
      Sorry, but the page you are looking for has note been found. Try checking
      the URL for error, then hit the refresh button on your browser or try
      found something else in our app.
    </div>
    <div class="flex justify-center mt-20">
      <button
        mat-button
        class="ib-btn ib-btn-outline ib-btn-secondary"
        (click)="toHome()"
      >
        Go To Home Page
      </button>
    </div>

    <!-- todo temp -->
    <div style="display: none">
      <button mat-button class="ib-btn-link" (click)="testError()">
        test Sentry
      </button>
    </div>
  </div>
</div>
<ib-footer></ib-footer>
